import styles from './Logo.module.scss'

type Props = {
    variant?: 'primary' | 'secondary'
    height?: number
}

export default function Logo({ variant = 'primary', height = 32 }: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1024 276"
            xmlSpace="preserve"
            height={height}
            className={styles.logo}
        >
            <path
                d="M404.24 100.86v21.83c-12.04-8.28-21.26-10.73-29.35-10.73-6.77 0-13.17 2.07-13.17 7.53 0 5.65 6.77 6.59 23.33 11.1 16.37 4.33 24.84 11.67 24.84 23.9 0 18.06-18.63 29.92-40.65 29.92-11.86 0-23.52-3.2-34.06-9.22v-23.14c9.22 7.53 19.95 13.55 31.99 13.55 8.66 0 15.99-3.39 15.99-9.41 0-4.7-2.07-7.15-18.44-10.91-22.39-5.08-29.35-13.92-29.35-25.22 0-15.81 15.05-27.29 37.45-27.29 9.59-.01 17.12 1.5 31.42 8.09zm109.33 36.12c0 27.47-20.7 47.42-40.65 47.42-11.29 0-16.56-3.01-26.72-9.6v48.36h-23.33V94.83h21.64l1.69 14.49c8.09-11.48 16.94-16.56 28.41-16.56 20.89 0 38.96 18.82 38.96 44.22zm-67.37 17.13c5.83 5.46 12.98 9.6 20.89 9.6 12.8 0 21.45-10.16 21.45-24.65 0-14.11-8.28-23.9-19.76-23.9-12.61 0-22.58 12.8-22.58 28.6v10.35zm169.73-15.43c0 24.84-20.13 45.73-48.36 45.73-27.66 0-47.8-19.76-47.8-45.54 0-25.78 21.45-46.1 46.86-46.1 29.73-.01 49.3 20.88 49.3 45.91zm-47.61 25.03c12.98 0 22.58-12.04 22.58-24.84 0-12.42-9.03-25.4-22.58-25.4-13.17 0-23.52 10.73-23.52 25.03 0 14.86 10.92 25.21 23.52 25.21zm87.31-95.03v26.34h24.46v17.5h-23.71v38.76c0 8.47 4.89 11.67 11.1 11.67 4.7 0 8.84-1.51 12.61-3.01v20.7c-6.96 2.07-14.11 3.01-21.08 3.01-16.56 0-25.97-8.84-25.97-24.65v-46.48h-14.49v-17.5h15.43l2.82-26.34h18.83zM716.03 54v128.33H692.7V54h23.33zm104.44 84.68c0 24.84-20.13 45.73-48.36 45.73-27.66 0-47.8-19.76-47.8-45.54 0-25.78 21.45-46.1 46.86-46.1 29.73-.01 49.3 20.88 49.3 45.91zm-47.61 25.03c12.98 0 22.58-12.04 22.58-24.84 0-12.42-9.03-25.4-22.58-25.4-13.17 0-23.52 10.73-23.52 25.03 0 14.86 10.91 25.21 23.52 25.21zm137.55-37.08v25.03c0 12.04 2.82 22.2 7.9 30.67h-27.29c-2.07-3.76-2.82-6.21-3.39-11.29-7.72 9.6-16.56 13.36-27.29 13.36-18.44 0-31.8-12.98-31.8-28.23 0-6.02 1.69-10.91 5.08-14.87 6.59-7.71 18.06-11.67 46.67-15.99l6.21-.94c-1.69-7.72-10.16-12.42-19.38-12.42-8.66 0-17.69 2.63-29.92 10.73v-21.26c10.73-5.27 22.02-8.66 34.06-8.66 25.41 0 39.15 14.87 39.15 33.87zm-44.97 39.33c11.29 0 21.26-9.97 23.33-25.22-25.59 3.39-35.94 6.4-35.94 15.43 0 6.59 6.02 9.79 12.61 9.79zm140.56-41.4v57.77h-23.33v-51.37c0-8.09-2.63-15.62-12.8-15.62-13.36 0-22.39 14.11-22.39 30.67v36.32h-23.33v-87.5h21.45l1.88 13.74c6.77-10.54 15.43-15.81 27.66-15.81 20.13 0 30.86 13.74 30.86 31.8z"
                fill={variant === 'primary' ? '#1b73aa' : '#fff'}
            />
            <radialGradient
                id="orange"
                cx="145.2804"
                cy="138.2222"
                r="173.2337"
                fx="190.5516"
                fy="-28.9915"
                gradientTransform="matrix(1 0 0 1.2038 0 -28.1711)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset=".8203" stopColor="#c66d2f" />
                <stop offset=".9525" stopColor="#c66d2f" />
            </radialGradient>
            <circle cx="145.28" cy="138.22" r="127.28" fill="url(#orange)" />
            <radialGradient
                id="yellow"
                cx="127.3681"
                cy="157.4972"
                r="153.0322"
                fx="171.5204"
                fy="10.9727"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset=".7901" stopColor="#f6d433" />
                <stop offset=".8857" stopColor="#f6d433" />
            </radialGradient>
            <circle cx="127.37" cy="157.5" r="87.57" fill="url(#yellow)" />
            <radialGradient
                id="blue"
                cx="146.3042"
                cy="136.7516"
                r="65.0912"
                fx="156.2966"
                fy="72.432"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset=".6195" stopColor="#4487c7" />
                <stop offset=".7759" stopColor="#4487c7" />
            </radialGradient>
            <circle cx="146.3" cy="136.75" r="48.11" fill="url(#blue)" />
        </svg>
    )
}
